import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { DeviceModelResponse } from '@/types/apps/device-model.type';
import type { GqlListResponse } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface DeviceModelGraphQLServiceInterface {}

type DeviceModelGraphQLListResponse = GqlListResponse<DeviceModelResponse>;

export class DeviceModelGraphQLService
    extends BaseService
    implements DeviceModelGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'deviceModel';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            deviceGroupCode: true,
            deviceGroupId: true,
            deviceSKUCode: true,
            deviceSKUId: true,
            deviceTypeCode: true,
            deviceTypeId: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            name: true,
            deviceGroup: {
                code: true,
                id: true,
                name: true,
                deviceType: {
                    id: true,
                    name: true,
                },
            },
            deviceSKU: {
                code: true,
                name: true,
                id: true,
            },
            deviceType: {
                name: true,
                id: true,
            },
        };
    }

    public async index(query: string): Promise<DeviceModelGraphQLListResponse> {
        return this.fetchGqlList<DeviceModelGraphQLListResponse>(
            query,
            this.getEntityName()
        );
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById() || !this.getRoleTypeManager().getQuery) {
            return {};
        }

        return this.getRoleTypeManager().getQuery('deviceModel', {
            userId: this.getQueryById(),
        });
    }
}
